var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ConciergeChatManager } from './concierge-manager-base';
import { SalesforceChatManager } from './concierge-manager-salesforce';
import { getUserInfo } from './integration/get-user-info';
import { waitForFeatureFlags } from '../../infra/feature-flags';
import { SalesforceMessagingSessionsManager } from './concierge-manager-salesforce-messaging-sessions';
var ForethoughtChatManager = /** @class */ (function (_super) {
    __extends(ForethoughtChatManager, _super);
    function ForethoughtChatManager() {
        var _this = _super.call(this, 'forethought') || this;
        _this.sfChatManager = null;
        _this.forethoughtscript = null;
        _this.mountSfChat = function () { return __awaiter(_this, void 0, void 0, function () {
            var useSalesforceMessagingSessions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, waitForFeatureFlags()];
                    case 1:
                        useSalesforceMessagingSessions = (_a.sent()).useSalesforceMessagingSessions;
                        this.sfChatManager = useSalesforceMessagingSessions
                            ? new SalesforceMessagingSessionsManager()
                            : new SalesforceChatManager();
                        return [2 /*return*/, this.sfChatManager.mount()];
                }
            });
        }); };
        _this.loadForethoughtScript = function (userInfo) {
            return new Promise(function (resolve) {
                var forethoughtscript = document.createElement('script');
                forethoughtscript.setAttribute('id', 'forethought-loading-script');
                forethoughtscript.setAttribute('src', 'https://solve-widget.forethought.ai/embed.js');
                forethoughtscript.setAttribute('type', 'application/javascript');
                forethoughtscript.setAttribute('data-api-key', '672de4d0-c3ab-4a9a-aa69-4495c20a708d');
                forethoughtscript.setAttribute('data-ft-Embed-Script-Language', 'en');
                forethoughtscript.setAttribute('offset-x', '40px');
                forethoughtscript.setAttribute('offset-y', '124px');
                forethoughtscript.setAttribute('data-ft-Full-Name', userInfo.name);
                forethoughtscript.setAttribute('data-ft-Comm-Username', userInfo.username);
                document.body.appendChild(forethoughtscript);
                _this.forethoughtscript = forethoughtscript;
                forethoughtscript.onload = function () {
                    resolve();
                };
            });
        };
        _this.mount = function () { return __awaiter(_this, void 0, void 0, function () {
            var userInfo, hasEmbeddedForethoughtObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mounted = true;
                        userInfo = getUserInfo();
                        hasEmbeddedForethoughtObject = !!window.Forethought;
                        if (!!hasEmbeddedForethoughtObject) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadForethoughtScript(userInfo)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.mountSfChat()];
                }
            });
        }); };
        _this.open = function () {
            var _a, _b;
            (_a = window.Forethought) === null || _a === void 0 ? void 0 : _a.call(window, 'widget', 'open');
            (_b = _this.sfChatManager) === null || _b === void 0 ? void 0 : _b.open();
        };
        _this.close = function () {
            var _a, _b;
            (_a = window.Forethought) === null || _a === void 0 ? void 0 : _a.call(window, 'widget', 'close');
            (_b = _this.sfChatManager) === null || _b === void 0 ? void 0 : _b.close();
        };
        return _this;
    }
    ForethoughtChatManager.prototype.unmount = function () {
        var _a;
        this.mounted = false;
        this.close();
        // just hiding the widget is not enough, because we send username in the script params
        // if user logs out and logs in with a different username, we need to re-initialize it correctly
        if (this.forethoughtscript) {
            document.body.removeChild(this.forethoughtscript);
        }
        var ftChatElement = document.getElementById('forethought-chat');
        if (ftChatElement) {
            document.body.removeChild(ftChatElement);
        }
        delete window.Forethought;
        (_a = this.sfChatManager) === null || _a === void 0 ? void 0 : _a.unmount();
    };
    return ForethoughtChatManager;
}(ConciergeChatManager));
export { ForethoughtChatManager };
